/* 
Intervals can be associated with an interaction in order to set the default
communication set for that interval for all children of the interaction in question. The interaction parent interval communicaiton set has 
priority over the communication set defined for the interval by default and under any communication set defined for the 
interaction node interval
*/

class InteractionParentInterval {
  id: number;
  interaction_parent_id: number;
  interval_id: number;
  communication_set_id: number | null;
  modified: string;
  constructor(
    id: number,
    interaction_parent_id: number,
    interval_id: number,
    communication_set_id: number | null,
    modified: string,
  ) {
    this.id = id;
    this.interaction_parent_id = interaction_parent_id;
    this.interval_id = interval_id;
    this.communication_set_id = communication_set_id;
    this.modified = modified;
  }
}

export default InteractionParentInterval;
